var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustryRelevantTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55",
    "data-name": "Group 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.112,
    height: 84.95,
    viewBox: "0 0 85.112 84.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 85.112,
    height: 84.95,
    fill: "#e68242"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M197.4,401.82h-1l-.561-.178-22.749.021c-.663.005-.7-.562-.745-1.08a62.061,62.061,0,0,1,.009-7.97c.971-13.69,24.959-14.2,25.876.157a56.319,56.319,0,0,1-.007,7.638,1.643,1.643,0,0,1-.829,1.41",
    transform: "translate(-142.803 -316.877)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M370.529,402.077c-.329-.013-.667.019-1,0a1.438,1.438,0,0,0-.561-.178c-7.7-.231-15.472.267-23.155-.07a1.373,1.373,0,0,1-.505-1.154c-.212-2.327-.049-8.856.711-10.918,3.92-10.633,24.285-9.473,25.174,2.608a61.392,61.392,0,0,1,0,8.642c-.078.572-.4.627-.672,1.07",
    transform: "translate(-286.243 -317.134)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M25.247,402.256h-1c-.172-.275-.629-.166-.91-.169-7.6-.08-15.228.134-22.807-.079l-.5-.582v-5.143l.173-.4c-2.889-15.906,24.685-17.9,25.706-3.339a61.854,61.854,0,0,1,0,8.643c-.078.572-.4.626-.672,1.07",
    transform: "translate(0 -317.313)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M224.174,0V33.181h-39.3a5.514,5.514,0,0,0-1.262-2.663l8.486-12.769-1.754-1.086-8.457,12.462-.5.007-5.015-2.749c-.075-.112-.454-.548-.454-.586V0Zm-4.809,4.977h-2.322V29.116a2.385,2.385,0,0,0,2.322,0Zm-19.072,9.954h-2.156V29.365h2.156Zm11.277,1h-2.156V29.282c.527.5,1.468.153,2.156.249ZM204.047,20.1l-.2.132-.049,8.863c.16.49,1.576.224,2.027.249l.2-.132.049-8.863c-.16-.49-1.576-.224-2.027-.249",
    transform: "translate(-145.857)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M28.85,131.895c-.346,2.349-3.707,2.61-3.986-.658-.423-4.952.025-16.6,6.137-18.1,2.056-.5,8.434-.444,10.7-.241,4.243.38,5.839,5.294,7.884,8.372,1.933,1.461,5.6,2.47,7.352,3.927,2.283,1.9-.015,5.6-2.747,4.742l-8.678-4.759c-.562-.421.036-2.118-.4-2.422-.338-.238-1.173.066-1.173.343v14.019H30.177V122.272c0-.6-.879-.679-1.327-.415Z",
    transform: "translate(-20.519 -93.488)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M40.926,283.334c10.34-1.4,10.943,13.484,1.611,13.892-8.823.386-9.69-12.8-1.611-13.892",
    transform: "translate(-29.318 -234.847)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M387,283.188c10.13-1.585,11.28,13.152,1.93,13.876-8.841.684-10.062-12.6-1.93-13.876",
    transform: "translate(-316.352 -234.704)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M213.488,283.368c8.774-1.188,11.388,10.3,4.133,13.26a6.975,6.975,0,0,1-9.487-8.329,7.167,7.167,0,0,1,5.353-4.931",
    transform: "translate(-172.36 -234.881)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M61.708,27.807c5.7-5.933,14.721,3.082,8.714,8.8-5.753,5.477-14.264-3.025-8.714-8.8",
    transform: "translate(-49.67 -21.444)",
    fill: "#e68242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryRelevantTraining);
export default __webpack_public_path__ + "static/media/industry_relevant_training.581f470e0aef71dade3aecece80dedd8.svg";
export { ForwardRef as ReactComponent };